import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  FaIdCard,
  FaMoneyCheckAlt,
  FaPhoneAlt,
  FaUniversity,
  FaUser,
} from "react-icons/fa";
import FileUpload from "../Constant/fileupload";
import { MdOutlineEmojiTransportation } from "react-icons/md";
import { useSelector } from "react-redux";
import {
  createDoorStepEmployeeApi,
  editDoorStepEmployeeDetailsApi,
} from "../../services/DoorStepEmployeeService";
import { apartmentChoice } from "../../utilities";
import Select from "react-select";
import axios from "axios";
const formatAadhar = (num) => {
  if (!num) return "";
  const digits = num.toString().replace(/\D/g, "");
  return digits.match(/.{1,4}/g)?.join(" ") || "";
};
const AddDoorStepEmployeeModal = ({
  visible,
  onClose,
  onAfterSubmit,
  data = null,
}) => {
  const [loading, setLoading] = useState(false);
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || "user"
  );
  const [selectedApartemnt, setSelectedApartment] = useState(null);
  const [form, setForm] = useState({
    name: "",
    mobile_number: "",
    adhar_number: "",
    adhar_image: "",
    pan_no: "",
    designation: "",
    apartment_type: "",
    bank_name: "",
    bank_account_number: "",
    bank_ifsc: "",
    fuel_allowance: "",
  });
  const [error, setError] = useState({});

  useEffect(() => {
    if (visible) handleReset();
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        name: data?.name || "",
        mobile_number: data?.mobile_number || "",
        adhar_number: formatAadhar(data?.adhar_no),
        adhar_image: data?.adhar_image || "",
        pan_no: data?.pan_no || "",
        designation: data?.designation || "",
        bank_name: data?.bank_name || "",
        bank_account_number: data?.bank_account_number || "",
        bank_ifsc: data?.bank_ifsc || "",
        fuel_allowance:Number(data?.fuel_allowance) || "",
      });
      setSelectedApartment(
        apartmentChoice?.find((item) => item?.value == data?.apartment_type) ||
          null
      );
    } else {
      setForm({
        name: "",
        mobile_number: "",
        adhar_number: "",
        adhar_image: "",
        pan_no: "",
        designation: "",
        apartment_type: "",
        bank_name: "",
        bank_account_number: "",
        bank_ifsc: "",
        fuel_allowance: "",
      });
      setSelectedApartment(null);
    }

    setError({});
  };

  useEffect(() => {
    if (selectedApartemnt?.value) {
      setForm({ ...form, apartment_type: selectedApartemnt?.value || "" });
    }
  }, [selectedApartemnt]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_number" && value) {
      const numericValue = value.replace(/[^0-9]/g, "");
      setForm((prev) => ({ ...prev, [name]: numericValue }));

      if (numericValue.length === 10) {
        if (error?.mobile_number) {
          setError((prev) => ({ ...prev, mobile_number: "" }));
        }
      } else {
        setError((prev) => ({ ...prev, mobile_number: "Must be 10 digits" }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
      if (error?.[name]) {
        setError((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = () => {
    let error = {};
    if (!form.name?.trim()) {
      error.name = "Name is required";
    }

    if (!form.fuel_allowance) {
      error.fuel_allowance = "This is required";
    }
    if (form?.mobile_number) {
      if (!/^[6-9]\d{9}$/.test(form.mobile_number)) {
        error.mobile_number = "Enter a valid 10-digit mobile number";
      }
    }

    if (!form.adhar_number?.trim()) {
      error.adhar_number = "Aadhar Number is required";
    } else if (!/^\d{4}\s\d{4}\s\d{4}$/.test(form.adhar_number)) {
      error.adhar_number = "Enter a valid 12-digit Aadhaar Number";
    }

    if (form?.pan_no) {
      if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(form.pan_no)) {
        error.pan_no = "Enter a valid PAN Number (e.g. ABCDE1234F)";
      }
    }
    if (form?.bank_account_number) {
      if (!/^\d{9,18}$/.test(form.bank_account_number)) {
        error.bank_account_number =
          "Enter a valid Bank Account Number (9–18 digits)";
      }
    }
    if (form?.ifsc) {
      if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.bank_ifsc)) {
        error.bank_ifsc = "Enter a valid IFSC Code (e.g. HDFC0001234)";
      }
    }

    setError(error);

    if (Object.keys(error).length === 0) {
      const formData = new FormData();

      formData.append("name", form?.name || "");
      formData.append("apartment_type", form?.apartment_type || "");
      formData.append("designation", form?.designation || "");
      formData.append("mobile_number", form?.mobile_number || "");
      formData.append(
        "adhar_no",
        form?.adhar_number ? form.adhar_number.replace(/\s/g, "") : ""
      );
      if (form?.adhar_image instanceof File) {
        formData.append("adhar_image", form.adhar_image);
      }
      formData.append("pan_no", form?.pan_no || "");
      formData.append("bank_name", form?.bank_name || "");
      formData.append("bank_account_number", form?.bank_account_number || "");
      formData.append("bank_ifsc", form?.bank_ifsc || "");
      formData.append("fuel_allowance", form?.fuel_allowance || "");

      if (data) {
        updateEmployee(formData);
      } else {
        addEmployee(formData);
      }
    }
  };

  const addEmployee = (payload) => {
    setLoading(true);
    createDoorStepEmployeeApi(payload)
      .then(() => {
        toast.success("Employee Added successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  const updateEmployee = (payload) => {
    setLoading(true);
    editDoorStepEmployeeDetailsApi(data?.id || "", payload)
      .then(() => {
        toast.success("Employee update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  const handleIfscBlur = async () => {
    const ifsc = form.bank_ifsc?.toUpperCase();
    if (/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) {
      try {
        const res = await axios.get(`https://ifsc.razorpay.com/${ifsc}`);
        setForm((prev) => ({
          ...prev,
          bank_ifsc: ifsc,
          bank_name: res.data.BANK,
        }));
      } catch (err) {
        // setError((prev) => ({ ...prev, bank_ifsc: "Invalid IFSC code" }));
        console.log(err);
      }
    }
  };
  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{data ? "Update Employee" : "Add Employee"}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div className="p-1">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label text-dark">
                Name<span className="text-danger ms-1">*</span>
              </label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px" }}
                >
                  <FaUser />
                </span>
                <input
                  type="text"
                  name="name"
                  className={`form-control px-5 ${
                    error?.name ? "is-invalid" : ""
                  }`}
                  value={form.name}
                  placeholder="Enter Name"
                  onChange={handleInputChange}
                />
              </div>
              {error?.name && (
                <small className="text-danger">{error.name}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label text-dark">Mobile</label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px" }}
                >
                  <FaPhoneAlt />
                </span>
                <input
                  type="text"
                  name="mobile_number"
                  className={`form-control px-5 ${
                    error?.mobile_number ? "is-invalid" : ""
                  }`}
                  value={form.mobile_number}
                  placeholder="9876543210"
                  onChange={handleInputChange}
                />
              </div>
              {error?.mobile_number && (
                <small className="text-danger">{error.mobile_number}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label text-dark">Apartment</label>
              <Select
                options={apartmentChoice}
                value={selectedApartemnt}
                onChange={setSelectedApartment}
                placeholder="Select Apartment"
                className="react-select"
                classNamePrefix="select"
              />
              {error?.apartment_type && (
                <small className="text-danger">{error.apartment_type}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label text-dark">Designation</label>
              <input
                type="text"
                name="designation"
                className={`form-control ${
                  error?.designation ? "is-invalid" : ""
                }`}
                value={form.designation}
                placeholder="Enter Designation"
                onChange={handleInputChange}
              />
              {error?.designation && (
                <small className="text-danger">{error.designation}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label text-dark">
                Aadhaar<span className="text-danger ms-1">*</span>
              </label>
              <input
                type="text"
                name="adhar_number"
                className={`form-control ${
                  error?.adhar_number ? "is-invalid" : ""
                }`}
                value={form.adhar_number}
                placeholder="XXXX XXXX XXXX"
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, "");
                  if (value.length > 0) {
                    value = value.match(/.{1,4}/g).join(" ");
                  }
                  value = value.toUpperCase();
                  handleInputChange({
                    target: { name: "adhar_number", value },
                  });
                }}
              />
              {error?.adhar_number && (
                <small className="text-danger">{error.adhar_number}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label text-dark">PAN Number</label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px" }}
                >
                  <FaIdCard />
                </span>
                <input
                  type="text"
                  name="pan_no"
                  className={`form-control px-5 ${
                    error?.pan_no ? "is-invalid" : ""
                  }`}
                  value={form.pan_no}
                  placeholder="ABCDE1234F"
                  onChange={(e) => {
                    let value = e.target.value.toUpperCase();
                    handleInputChange({ target: { name: "pan_no", value } });
                  }}
                />
              </div>
              {error?.pan_no && (
                <small className="text-danger">{error.pan_no}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">IFSC Code</label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px" }}
                >
                  <FaMoneyCheckAlt />
                </span>
                <input
                  type="text"
                  name="bank_ifsc"
                  className={`form-control px-5 ${
                    error?.bank_ifsc ? "is-invalid" : ""
                  }`}
                  value={form.bank_ifsc}
                  placeholder="HDFC0001234"
                  onChange={handleInputChange}
                  onBlur={handleIfscBlur}
                />
              </div>
              {error?.bank_ifsc && (
                <small className="text-danger">{error.bank_ifsc}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label text-dark">Bank Name</label>
              <input
                type="text"
                name="bank_name"
                className={`form-control ${
                  error?.bank_name ? "is-invalid" : ""
                }`}
                value={form.bank_name}
                placeholder="Bank Name"
                onChange={handleInputChange}
              />
              {error?.bank_name && (
                <small className="text-danger">{error.bank_name}</small>
              )}
            </div>
            <div className="col-12">
              <label className="form-label text-dark">
                Bank Account Number
              </label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px" }}
                >
                  <FaUniversity />
                </span>
                <input
                  type="text"
                  name="bank_account_number"
                  className={`form-control px-5 ${
                    error?.bank_account_number ? "is-invalid" : ""
                  }`}
                  value={form.bank_account_number}
                  placeholder="Enter Bank Account Number"
                  onChange={handleInputChange}
                />
              </div>
              {error?.bank_account_number && (
                <small className="text-danger">
                  {error.bank_account_number}
                </small>
              )}
            </div>
            <div className="col-12">
              <label className="form-label text-dark">
                Fuel Allownace<span className="text-danger ms-1">*</span>
              </label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px" }}
                >
                  <MdOutlineEmojiTransportation />
                </span>
                <input
                  type="text"
                  name="fuel_allowance"
                  className={`form-control px-5 ${
                    error?.fuel_allowance ? "is-invalid" : ""
                  }`}
                  value={form.fuel_allowance}
                  placeholder="1500"
                  onChange={handleInputChange}
                />
              </div>
              {error?.fuel_allowance && (
                <small className="text-danger">{error.fuel_allowance}</small>
              )}
            </div>
            <div className="col-12 mb-0">
              <label className="form-label text-dark">Adhar Image</label>
            </div>
            <div className="col-6 mt-0">
              <FileUpload
                label="Adhar Image"
                accept=".jpg,.jpeg,.png"
                multiple={false}
                value={form?.adhar_image}
                onChange={(files) => {
                  setForm((prev) => ({ ...prev, adhar_image: files }));
                  //   if (files) {
                  //     setError({ ...error, adhar_image: "" });
                  //   }
                }}
              />
              {/* {error?.adhar_image && (
                      <small className="text-danger mb-3">{error.adhar_image}</small>
                    )} */}
            </div>
            <div className="col-6 mt-0">
              <div
                className="card shadow-sm"
                style={{ height: "100px", overflow: "hidden" }}
              >
                {form?.adhar_image ? (
                  <img
                    src={
                      form?.adhar_image instanceof File
                        ? URL.createObjectURL(form.adhar_image)
                        : form?.adhar_image
                        ? `${process.env.REACT_APP_BASE_URL}${form.adhar_image}`
                        : null
                    }
                    alt="Adhar Preview"
                    style={{
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center h-100"
                    style={{
                      backdropFilter: "blur(4px)",
                      backgroundColor: "rgba(0,0,0,0.1)",
                    }}
                  >
                    <span className="text-secondary fw-semibold">
                      Image Not Available
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />} Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddDoorStepEmployeeModal;
